import useRestList from "../../_shared/hooks/useRestList";
import { useEffect, useState } from "react";

import HandIcon from "../../../assets/images/icons/push.svg";
import YellowButton from "../../../assets/images/icons/Pulsante_lay.png";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import ReactHtmlParser from "react-html-parser";
import { Navigate, redirect, useParams } from "react-router-dom";

import AppButton from "../../_shared/components/AppButton";
import BackIcon from "../../_shared/components/BackIcon";
import AppText from "../../_shared/components/AppText";
import HtmlText from "../../_shared/components/HtmlText";
import SlideImages from "../../_shared/components/SlideImages";
import CloseIcon from "../../_shared/components/CloseIcon";
import SideMenu from "../../_shared/components/SideMenu";
import { Modal } from "antd";
import HeaderActions from "../../_shared/components/HeaderActions";

export default function Compositions(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);
  const [elements] = useRestList("/elementcompositions");
  const [videos] = useRestList("/videos", null, { pageSize: 100 });

  const { id } = useParams();

  const [composition, setComposition] = useState();
  const [selectedIndexImage, setSelectedIndexImage] = useState(0);

  const [selectedVideo, setSelectedVideo] = useState();
  const [openedVideo, setOpenedVideo] = useState();

  useEffect(() => {
    elements.map((comp) => comp?.id === id && setComposition(comp));
  }, [id, elements]);

  useEffect(() => {
    selectedVideo
      ? setOpenedVideo(videos.find((x) => x.id === selectedVideo))
      : setOpenedVideo();
  }, [selectedVideo]);

  function getMarginLeft(size) {
    switch (size) {
      case "0":
        return 70;
      case "1":
        return 4;
      case "2":
        return 136;
      case "3":
        return 225;
      default:
        return 0;
    }
  }

  const oneToOne = {
    marginLeft: 90,
    height: 200,
    aspectRatio: 1,

    resizeMode: "contain",
  };
  const twoToThree = {
    marginLeft: 90,
    height: 200,
    aspectRatio: 2 / 3,

    resizeMode: "contain",
  };
  const fourToThree = {
    marginLeft: 90,
    aspectRatio: 4 / 3,
    height: 200,

    resizeMode: "contain",
  };
  const sixToNine = {
    marginLeft: 90,
    height: 200,
    aspectRatio: 16 / 9,

    resizeMode: "contain",
  };

  function getImageSize(size, index) {
    switch (size) {
      case "0":
        return {
          ...oneToOne,
          marginLeft: index === 0 ? 0 : oneToOne.marginLeft,
        };

      case "1":
        return {
          ...twoToThree,
          marginLeft: index === 0 ? 0 : twoToThree.marginLeft,
        };

      case "2":
        return {
          ...fourToThree,
          marginLeft: index === 0 ? 0 : fourToThree.marginLeft,
        };

      case "3":
        return {
          ...sixToNine,
          marginLeft: index === 0 ? 0 : sixToNine.marginLeft,
        };

      default:
        return {
          ...oneToOne,
          marginLeft: index === 0 ? 0 : oneToOne.marginLeft,
        };
    }
  }

  function renderElement() {
    return (
      <div>
        <div
          className="row"
          style={{
            marginBottom: 30,
            display: "flex",
            justifyContent: "space-between",
            width: "85vw",
          }}
        >
          <div className="row">
            <div>
              <BackIcon></BackIcon>
            </div>
            <div>
              <AppText bold>{composition?.name?.it}</AppText>
              <AppText>{composition?.name?.en}</AppText>
            </div>
          </div>

          <HeaderActions />
        </div>
        <div style={{ marginLeft: 30, marginTop: 100 }}>
          {/* size */}
          <div className="row">
            {composition?.size?.split("<br>").map((xsize, index) => (
              <div
                style={{
                  width: 220,

                  marginLeft:
                    index === 0
                      ? 0
                      : getMarginLeft(
                          composition?.imagesDetail?.[index - 1]?.size
                        ),
                }}
              >
                <HtmlText text={xsize} />
              </div>
            ))}
          </div>

          {composition?.imagesDetail?.map((image, index) => (
            <img
              alt=""
              src={image?.image}
              style={getImageSize(image?.size, index)}
            ></img>
          ))}

          {/* Elements */}
          <div className="row" style={{ marginTop: 50 }}>
            {composition?.customField?.map((x) => (
              <div className="elementCard">
                <div className="row">
                  <AppText bold small underline>
                    {x?.name?.it?.replace(" ", "")}
                  </AppText>
                  <AppText small underline>
                    / {x?.name?.en}
                  </AppText>
                </div>

                <HtmlText lineHeight={1.5} text={x.text} />
              </div>
            ))}
            <div className="elementCard">
              <div className="row">
                <AppText bold small underline>
                  finiture
                </AppText>
                <AppText small light underline>
                  / finishes
                </AppText>
              </div>

              {composition?.finishes?.map((x) => (
                <div className="row">
                  <AppText small bold>
                    {x?.name?.it}
                  </AppText>
                  <AppText small light>
                    / {x?.name?.en}
                  </AppText>
                </div>
              ))}
              {composition?.fabrics?.map((x) => (
                <div>
                  <div className="row">
                    <AppText bold small>
                      {x?.name?.it}
                    </AppText>
                    <AppText bold small>
                      {x?.parentFabric?.name?.it}
                    </AppText>

                    {x?.name?.en && (
                      <div className="row">
                        <AppText light small>
                          / {x?.name?.en} {x?.parentFabric?.name?.en}
                        </AppText>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* Carousel */}

          <SlideImages
            image={
              composition?.images && composition?.images[selectedIndexImage]
            }
            pickPointsVideo={composition?.pickPoints?.filter(
              (x) => x?.indexImage === selectedIndexImage?.toString()
            )}
            onPlus={() =>
              selectedIndexImage === composition?.images.length - 1
                ? setSelectedIndexImage(0)
                : setSelectedIndexImage(selectedIndexImage + 1)
            }
            onMinus={() =>
              selectedIndexImage === 0
                ? setSelectedIndexImage(composition?.images.length - 1)
                : setSelectedIndexImage(selectedIndexImage - 1)
            }
            showArrows={composition?.images?.length > 1}
            setSelectedVideo={setSelectedVideo}
            style={{ maxWidth: "80vw" }}
            noCenter
          ></SlideImages>
        </div>
      </div>
    );
  }

  return (
    <div className="rootMenu">
      <SideMenu></SideMenu>
      <div className="rootContent">{composition && renderElement()}</div>
      <Modal
        open={openedVideo}
        className="modal"
        bodyStyle={{ height: "85vh", overflowY: "auto" }}
        footer={[]}
        closable={false}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <CloseIcon onClick={() => setSelectedVideo()} />
        </div>
        <video
          autoPlay
          src={openedVideo?.video}
          width="100%"
          height="100%"
          controls
        />
      </Modal>
    </div>
  );
}
